import React from "react";
import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar, Sidebar } from "./components";
import {
  About,
  AdminCreateGroups,
  ModManagementPage,
  AdminDivisions,
  AdminGroupPlayers,
  AdminHallOfFame,
  AdminHome,
  AdminMatches,
  AdminMergePlayers,
  AdminRegistrations,
  AdminTournamentDetails,
  AdminTournamentMatches,
  AdminUsers,
  BigAnnouncement,
  DivisionPage,
  Donations,
  Error,
  Group,
  HallOfFamePage,
  HallOfFamePageT5,
  HomePage2024,
  HomeTournament,
  Home,
  MatchPage,
  MatchOldPage,
  Profile,
  RegisterTournamentOkPage,
  RegisterTournamentPage,
  RegisterStreamerTournamentPage,
  RegistersListPage,
  Temp3,
  Temp4,
  Temp5InfoPage,
  Temp5PlayoffPage,
  TournamentInfo,
  T7DivisionListPage,
  LeaderboardPage,
} from "./pages/index";
import { StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";

function App() {
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
    },
  });
  return (
    <ThemeProvider theme={darkTheme}>
      <StyledEngineProvider injectFirst>
        <Router>
          <Navbar />
          <Sidebar />
          {/* <Notification /> */}
          <Routes>
            <Route exact path="/" element={<HomePage2024 />} />
            <Route exact path="/season7" element={<T7DivisionListPage />} />
            <Route
              exact
              path="/tournament/:tournamentId/home"
              element={<HomeTournament />}
            />
            <Route exact path="/old-home" element={<Home />} />
            <Route path="/announcement" element={<BigAnnouncement />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/player/:playerId" element={<Profile />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/leaderboard" element={<LeaderboardPage />} />
            <Route exact path="/donations" element={<Donations />} />
            <Route exact path="/hall-of-fame" element={<HallOfFamePage />} />
            <Route
              exact
              path="/register/tournament/:tournamentId"
              element={<RegisterTournamentPage />}
            />
            <Route
              exact
              path="/tournament/register-ok"
              element={<RegisterTournamentOkPage />}
            />
            <Route
              exact
              path="/tournament/:tournamentId"
              element={<TournamentInfo />}
            />
            <Route
              exact
              path="/hall-of-fame-t5"
              element={<HallOfFamePageT5 />}
            />
            <Route exact path="/temporada-3" element={<Temp3 />} />
            <Route exact path="/temporada-4" element={<Temp4 />} />
            {/*<Route exact path="/registrations-t5-extended">
          <RegisterT5 />
        </Route>
         <Route exact path="/temporada-5">
          <Temp5 />
        </Route> */}
            <Route exact path="/info-temporada-5" element={<Temp5InfoPage />} />
            <Route
              exact
              path="/registers/:tournamentId"
              element={<RegistersListPage />}
            />
            <Route exact path="/playoffs-t5" element={<Temp5PlayoffPage />} />
            <Route
              path="/season/:seasonId/group/:groupId"
              element={<Group />}
            />
            <Route
              path="/division/:divisionId/group/:groupId"
              element={<DivisionPage />}
            />
            <Route
              exact
              path="/match/:matchId/detail"
              element={<MatchPage />}
            />
            <Route exact path="/match/:matchId" element={<MatchOldPage />} />
            <Route
              exact
              path="/register/:tournamentId/streamer"
              element={<RegisterStreamerTournamentPage />}
            />
            {/* ========================== ADMIN PAGES ========================== */}
            <Route exact path="/admin" element={<AdminHome />} />
            <Route
              exact
              path="/admin/registrations/:tournamentId"
              element={<AdminRegistrations />}
            />
            <Route
              exact
              path="/admin/tournament/:tournamentId"
              element={<AdminDivisions />}
            />
            <Route
              exact
              path="/admin/tournament/:tournamentId/groups-management"
              element={<AdminCreateGroups />}
            />
            <Route
              exact
              path="/admin/tournament/:tournamentId/matches"
              element={<AdminTournamentMatches />}
            />
            <Route
              exact
              path="/admin/tournament/:tournamentId/matches/create"
              element={<AdminMatches />}
            />
            <Route
              exact
              path="/admin/tournament/:tournamentId/details"
              element={<AdminTournamentDetails />}
            />
            <Route
              exact
              path="/admin/tournament/:tournamentId/division/:divisionId/group/:groupId"
              element={<AdminGroupPlayers />}
            />
            <Route exact path="/admin/mods" element={<ModManagementPage />} />
            <Route exact path="/admin/merge-players" element={<AdminMergePlayers />} />
            <Route exact path="/admin/users" element={<AdminUsers />} />
            <Route
              exact
              path="/admin/tournament/:tournamentId/hall-of-fame"
              element={<AdminHallOfFame />}
            />
            {/*< Route exact path="/admin/groups">
          <AdminGroups />
        </Route>
        <Route
          exact
          path="/admin/classification/season/:seasonId/group/:groupId"
        >
          <AdminClassification />
        </Route> */}
            <Route exact path="*" element={<Error />} />
          </Routes>
          {/* <Footer /> */}
        </Router>
      </StyledEngineProvider>
    </ThemeProvider>
  );
}

export default App;
